import React from "react";
import { Routes, Route } from "react-router-dom";
import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import Home from "./pages/Home";
import CorporateTraining from "./pages/CorporateTraining";
import Contact from "./pages/Contact";
import ITSolutions from "./pages/ITSolutions";

function App() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/training" element={<CorporateTraining />} />
        <Route path="/solutions" element={<ITSolutions />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
